rhm.index = (function (module) {
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.longtext_expander')) return;
    document.querySelectorAll('.longtext_container').forEach(function (el) {
      el.classList.toggle('expand');
    });
  });
  document.dispatchEvent(new CustomEvent('loadGlobalDeferred'));
})(window.rhm.index);
